document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.custom-hero-slider-section');

  sliders.forEach(section => {
    const track = section.querySelector('.custom-hero-slider__track');
    const slides = track.querySelectorAll('.custom-hero-slide');
    const allDots = section.querySelectorAll('.custom-hero-slider__dot');
    
    if (!track || slides.length <= 1) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let autoplayInterval;
    const autoplay = section.dataset.autoplay === 'true';
    const duration = parseInt(section.dataset.duration) || 5000;
    
    allDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index);
        const slideWidth = track.clientWidth;
        track.scrollTo({
          left: slideWidth * index,
          behavior: 'smooth'
        });
        resetAutoplay();
      });
    });

    track.addEventListener('scroll', () => {
      const scrollPosition = track.scrollLeft;
      const slideWidth = track.clientWidth;
      
      const currentIndex = Math.round(scrollPosition / slideWidth);
      
      allDots.forEach((dot) => {
        if (parseInt(dot.dataset.index) === currentIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    });

    if (autoplay) {
      track.style.overflowX = 'hidden';
      track.style.touchAction = 'none';
      track.style.pointerEvents = 'none';
      
      const interactiveElements = section.querySelectorAll('.custom-hero-slider__nav, .custom-hero-btn');
      interactiveElements.forEach(el => {
        el.style.pointerEvents = 'auto';
      });
    }

    if (!autoplay) {
      track.addEventListener('mousedown', (e) => {
        isDown = true;
        track.style.scrollSnapType = 'none';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        resetAutoplay();
      });

      track.addEventListener('mouseleave', () => {
        isDown = false;
        track.style.scrollSnapType = 'x mandatory';
      });

      track.addEventListener('mouseup', () => {
        isDown = false;
        track.style.scrollSnapType = 'x mandatory';
        
        const slideWidth = track.clientWidth;
        const currentIndex = Math.round(track.scrollLeft / slideWidth);
        
        track.scrollTo({
          left: slideWidth * currentIndex,
          behavior: 'smooth'
        });
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 2;
        track.scrollLeft = scrollLeft - walk;
      });
    }

    const startAutoplay = () => {
      if (!autoplay) return;
      stopAutoplay();
      autoplayInterval = setInterval(() => {
        const slideWidth = track.clientWidth;
        const currentScroll = track.scrollLeft;
        const currentIndex = Math.round(currentScroll / slideWidth);
        const totalSlides = slides.length;
        
        let nextIndex = currentIndex + 1;
        if (nextIndex >= totalSlides) {
          nextIndex = 0;
        }
        
        track.scrollTo({
          left: nextIndex * slideWidth,
          behavior: 'smooth'
        });
      }, duration);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    const resetAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    startAutoplay();
  });
});
